// Compteur unique de "curieux en ligne" — partagé par la bannière (OnlineNow)
// et la carte des flux (MapDesLueurs), pour afficher rigoureusement le même nombre.
let value = 172 + Math.floor(Math.random() * 78); // 172–249
const subscribers = new Set();
let timer = null;

function tick() {
  const delta = Math.floor(Math.random() * 9) - 4; // -4..+4
  value = Math.min(360, Math.max(150, value + delta));
  subscribers.forEach((cb) => { try { cb(value); } catch { /* noop */ } });
  timer = setTimeout(tick, 3500 + Math.random() * 2500);
}

export function getOnlineCount() {
  return value;
}

export function subscribeOnlineCount(cb) {
  subscribers.add(cb);
  cb(value);
  if (timer === null) {
    timer = setTimeout(tick, 3500 + Math.random() * 2500);
  }
  return () => {
    subscribers.delete(cb);
    if (subscribers.size === 0 && timer) {
      clearTimeout(timer);
      timer = null;
    }
  };
}
